import React from "react";
import Tools from "./Tools";

const Section = props => {
  const { divClasses, connectDragSource, Component, id, meta } = props;
  return (
    <div className={divClasses}>
      <Tools connectDragSource={connectDragSource} id={id} meta={meta} />
      <Component {...props} />
    </div>
  );
};

export default Section;
